import React, { useState, useEffect } from "react";
import "./OpportunityFilterComponent.css";
import { ucfirst } from "../../../../TableComponents/tableUtils";

const OpportunityFilterComponent = ({
  filterOptions = {},
  defaultFilterTab = "signal",
  filters = {},
  setFilters = () => {},
  loading,
  setIsDropdownOpen
}) => {

  const [activeTab, setActiveTab] = useState(defaultFilterTab);
  const [tempFilters, setTempFilters] = useState(filters);
  const [searchQuery, setSearchQuery] = useState("");

  // ✅ Custom display names
  const tabDisplayNames = {
    tag: "Signals",
    location:"Geography",
    mapped_products:"Relevant Offerings",
    relevance:"Relevance",
    city:"City",
    country:"Country",
    icp_keyword:"ICP Keyword",
    fileType:"File Type",
    account_industries:"Account Industries",
    company_type:"Company Type",
    business_unit:"Business Unit"

    // Add more mappings as needed
  };

  useEffect(() => {
    const cleaned = Object.fromEntries(
      Object.entries(filters).filter(([key]) => filterOptions?.[key])
    );
    setTempFilters(cleaned);
  }, [filters, filterOptions]);

  useEffect(() => {
    if (!filterOptions[activeTab]) {
      const firstTab = Object.keys(filterOptions)[0];
      setActiveTab(firstTab || "");
    }
  }, [filterOptions]);

  const isSelected = (category, value) =>
    tempFilters?.[category]?.includes(value);

  const toggleSelectAll = (category) => {
    console.log("toggleSelectAll category",filterOptions,category)
    const allOptions = filterOptions?.[category] ?? [];
    const isAllSelected = tempFilters?.[category]?.length === allOptions.length;

    setTempFilters((prev) => ({
      ...prev,
      [category]: isAllSelected ? [] : [...allOptions],
    }));
  };

  const toggleOption = (category, value) => {
    setTempFilters((prev) => {
      const current = prev?.[category] ?? [];
      const updated = current.includes(value)
        ? current.filter((item) => item !== value)
        : [...current, value];

      return {
        ...prev,
        [category]: updated,
      };
    });
  };

  const handleFilterChange = (category, value) => {
    if (value === "Select All") {
      toggleSelectAll(category);
    } else {
      toggleOption(category, value);
    }
  };

  const handleApply = () => {
    const cleaned = Object.fromEntries(
      Object.entries(tempFilters).map(([k, v]) => [k, v?.filter(Boolean)])
    );
    setFilters(cleaned);
    setIsDropdownOpen(false);
  };

  const handleCancel = () => {
    setTempFilters({});
    setSearchQuery("");
    setFilters({});
    setIsDropdownOpen(false);
  };

  const handleClear = () => {
    setTempFilters({});
    setSearchQuery("");
    setFilters({});
  };

  const filteredOptions = (filterOptions?.[activeTab] ?? []).filter((option) =>
   {
    return option &&  option?.toLowerCase()?.includes(searchQuery?.toLowerCase())}
  );

  return (
    <div className="opportunity-filter-component">
      <div className="opportunity-filter-header">
        <div className="opportunity-filter-txt">Filters</div>
        <button className="opportunity-filter-txt" onClick={handleClear}>
          Clear All
        </button>
      </div>

      <div className="opportunity-filter-body">
        <div className="opportunity-filter-tabs">
          {Object.keys(filterOptions)?.map((tab) => (
            <button
              key={tab}
              className={`opportunity-filter-tab ${
                activeTab === tab ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab(tab);
                setSearchQuery("");
              }}
            >
              {tabDisplayNames[tab] || tab}
              {tempFilters?.[tab]?.length > 0 && (
                <span className="filter-count">{tempFilters[tab].length}</span>
              )}
            </button>
          ))}
        </div>

        <div className="opportunity-filter-content">
          <div className="opportunity-filter-search-container">
            <input
              type="text"
              placeholder="Search"
              className="opportunity-filter-search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="opportunity-filter-options">
            <label className="opportunity-filter-option">
              <input
                type="checkbox"
                checked={
                  (tempFilters?.[activeTab]?.length ?? 0) ===
                  (filterOptions?.[activeTab]?.length ?? 0)
                }
                onChange={() => handleFilterChange(activeTab, "Select All")}
              />
              <span className="checkbox-label">Select All</span>
            </label>

            {filteredOptions.map((option) => (
              <label key={option} className="opportunity-filter-option">
                <input
                  type="checkbox"
                  checked={isSelected(activeTab, option)}
                  onChange={() => handleFilterChange(activeTab, option)}
                />
                <span className="checkbox-label">{ucfirst(option)}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="opportunity-filter-footer">
        <button className="opportunity-filter-cancel" onClick={handleCancel}>
          Cancel
        </button>

        {loading ? (
          <div className="btn-spinner" />
        ) : (
          <button className="opportunity-filter-apply" onClick={handleApply}>
            Apply
          </button>
        )}
      </div>
    </div>
  );
};

export default OpportunityFilterComponent;
